import { User } from "../../../auth/types";
import { httpWebApi } from "../../../../core/http/httpThunks";

export const printTradingData = (user: User, ptdid: string) => {
	return httpWebApi<Blob>({
		method: "GET",
		responseType: "blob",
		timeout: 60 * 4 * 1000,
		url: "reporting/getprodtradingdatacalcreport",
		params: {
			userid: user.userId,
			ptdid,
		},
	});
};

export default printTradingData;
